export const HEADER_PHONE_FALLBACK_DISPLAY = "0900 - 66 11 11 1";
export const HEADER_PHONE_FALLBACK_HREF = "tel:0900-6611111";

export interface HeaderPhoneInterface {
    display: string;
    href: string;
}

const HEADER_PHONE_FALLBACK: HeaderPhoneInterface = {
    display: HEADER_PHONE_FALLBACK_DISPLAY,
    href: HEADER_PHONE_FALLBACK_HREF,
};

export const getHeaderPhone = (telephone?: string[]): HeaderPhoneInterface => {
    const firstTelephone = telephone?.[0];

    if (firstTelephone === undefined || firstTelephone.trim() === "") {
        return HEADER_PHONE_FALLBACK;
    }

    return {
        display: firstTelephone,
        href: "tel:" + firstTelephone,
    };
};
